export default function ({ store, navigator }) {
  return null
}
